import React, { createContext, useContext, useEffect, useState } from "react";
import { authLogin, authLogout, authMe } from "../lib/api";

const AuthContext = createContext({
  user: null, // null = checking, false = not logged in, object = authed
  login: async () => {},
  logout: async () => {},
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const me = await authMe();
        if (!cancelled) setUser(me);
      } catch {
        // 401 is expected for unauth'd visitors — silent fallback
        if (!cancelled) setUser(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const login = async (email, password) => {
    const data = await authLogin(email, password);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await authLogout(); } catch { /* noop */ }
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
